module.exports = __webpack_public_path__ + "static/img/menage4.cafcba38.png";